import React, { FC } from 'react'
import { Spacing } from 'Pages/landings/newLandings/common/style'
import { LayoutComponent } from 'Pages/landings/newLandings/common/Layout'
import { BannerComponent } from 'Pages/landings/newLandings/selfEmployed/Banner'
import { AreYouRegisteredComponent } from 'Pages/landings/newLandings/selfEmployed/AreYouRegistered'
import { FormComponent } from 'Pages/landings/newLandings/selfEmployed/Form'
import { CookieHandlingNotice } from 'Pages/landings/newLandings/common/components'
import { ToolsComponent } from 'Pages/landings/newLandings/selfEmployed/Tools'
import { Footer } from 'Pages/landings/newLandings/selfEmployed/Footer'

const LandingSelfEmployed: FC = () => (
	<LayoutComponent
		title="Станьте самозанятым со Сбером"
		menuButton="form"
		menuButtonText="Оставить заявку"
		footerComponent={<Footer />}
	>
		<Spacing height="24px" heightLX="32px" />
		<BannerComponent />
		<Spacing height="32px" heightLX="80px" />
		<AreYouRegisteredComponent />
		<Spacing height="64px" heightLX="80px" />
		<ToolsComponent />
		<Spacing height="64px" heightLX="80px" />
		<FormComponent />
		<CookieHandlingNotice />
	</LayoutComponent>
)
export default LandingSelfEmployed
